<template>
    <label class="col-form-label" :for="name">{{ label }}</label>
    <input :name="name" :id="name" :type="type" :value="inputValue" :placeholder="placeholder" :min="min"
        @input="onInput($event)" @blur="handleBlur" :class="`form-control ${errorMessage ? 'is-invalid' : 'is-valid'}`"
        :disabled="disabled" />
    <span :class="`d-inline-block ${errorMessage ? 'invalid-feedback' : 'valid-feedback'}`" v-show="errorMessage">
        {{ errorMessage }}
    </span>
</template>

<script>
import { useField } from "vee-validate";

export default {
    props: {
        type: {
            type: String,
            default: "text",
        },
        modelValue: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String
        },
        successMessage: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false
        },
        min: {
            type: Number,
            default: "",
        }
    },
    setup(props, { emit }) {
        const {
            value: inputValue,
            errorMessage,
            handleBlur,
            handleChange,
            meta,
        } = useField(props.name, "", {
            syncVModel: true
        });

        const onInput = (event) => {
            handleChange(event, true)
            emit('update:modelValue', event.target.value)
        }

        return {
            onInput,
            handleChange,
            handleBlur,
            errorMessage,
            inputValue,
            meta,
        };
    },
};
</script>

<style type="text/css"></style>
